import React from 'react';
const RightArrowIcon = ({ stroke = '#6E6E77' }) => {
    return (React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8.4587 2.62537L12.8337 7.00033L8.4587 11.3753M12.8337 7.00033L1.16699 7.00017", stroke: stroke, "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default RightArrowIcon;
